import { render, staticRenderFns } from "./AnswerSelector.vue?vue&type=template&id=3cf54daf&scoped=true&"
import script from "./AnswerSelector.vue?vue&type=script&lang=js&"
export * from "./AnswerSelector.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSelector.vue?vue&type=style&index=0&id=3cf54daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf54daf",
  null
  
)

export default component.exports